import { OfferPayload } from "../../../services/redux/types/CartLoyaltyV2Types";
import Offer from "../../OfferClass/Offer/Offer";
import { createOffer } from "../../OfferClass/OfferClassUtils/OfferCreator/offerCreator";
import { OfferType } from "../../types";

function isLegacyOfferShape(offer: OfferType | Offer): offer is OfferType {
  return (
    !(offer instanceof Offer) &&
    typeof (offer as Offer).isEqual !== "function" &&
    typeof offer === "object" &&
    offer !== null &&
    "offerType" in offer
  );
}

function toLegacyOfferInstance(offer: OfferType | Offer): Offer | undefined {
  const legacyOffer = offer as Offer;

  if (offer instanceof Offer || typeof legacyOffer.isEqual === "function") {
    return legacyOffer;
  }

  if (!isLegacyOfferShape(offer)) {
    return undefined;
  }

  const created = createOffer(offer);

  return typeof created.isEqual === "function" ? created : undefined;
}

export function findLegacyRedeemedOffer(
  offersArray: Array<OfferType | Offer>,
  redeemedOffer?: OfferPayload
): Offer | undefined {
  if (!redeemedOffer) {
    return undefined;
  }

  for (const raw of offersArray) {
    const offer = toLegacyOfferInstance(raw);
    if (offer?.isEqual(redeemedOffer)) {
      return offer;
    }
  }

  return undefined;
}
